import React from "react";
import { Dialog, DialogTitle, DialogContent, DialogActions, Button } from "@mui/material";
import ByzMuiSnackBar from "src/components/core-components/mui/ByzMuiSnackBar";
import ByzDeleteConfirmDialog from "src/components/core-components/mui/ByzDeleteConfirmDialog";
import ByzMuiTypography from "src/components/core-components/mui/inputs/ByzMuiTypography";
import { useTranslate } from "src/locales";

interface PartographDialogsProps {
    error: any;
    setError: (val: any) => void;
    alertOpen: boolean;
    setAlertOpen: (val: boolean) => void;
    alertSeverity: "error" | "warning" | "info" | "success";
    alertMessage: string;
    deleteDialogOpen: boolean;
    setDeleteDialogOpen: (val: boolean) => void;
    handleConfirmDelete: () => void;
    genderWarningOpen: boolean;
    setGenderWarningOpen: (val: boolean) => void;
    onCloseModal?: () => void;
}

const PartographDialogs: React.FC<PartographDialogsProps> = ({
    error,
    setError,
    alertOpen,
    setAlertOpen,
    alertSeverity,
    alertMessage,
    deleteDialogOpen,
    setDeleteDialogOpen,
    handleConfirmDelete,
    genderWarningOpen,
    setGenderWarningOpen,
    onCloseModal,
}) => {
    const { t } = useTranslate();

    return (
        <>
            {/* Error Snackbar */}
            {error && (
                <ByzMuiSnackBar
                    open={error.open}
                    onClose={() => setError({ message: "", open: false })}
                    title={t("error") || "Hata"}
                    message={error.message}
                    type="error"
                />
            )}

            {/* Success/Info Alert */}
            <ByzMuiSnackBar
                open={alertOpen}
                onClose={() => setAlertOpen(false)}
                title={
                    alertSeverity === "success"
                        ? t("operation-successful") || "Başarılı"
                        : t("error") || "Hata"
                }
                message={alertMessage}
                type={alertSeverity === "success" ? "success" : "error"}
            />

            <ByzDeleteConfirmDialog
                open={deleteDialogOpen}
                onClose={() => setDeleteDialogOpen(false)}
                title={t("card.delete-confirmation") || "Silme Onayı"}
                content={
                    t("card.delete-confirmation-message") ||
                    "Bu kaydı silmek istediğinizden emin misiniz?"
                }
                onConfirm={handleConfirmDelete}
                onSuccess={(success) => {
                    if (success) {
                        setDeleteDialogOpen(false);
                    }
                }}
            />

            <Dialog
                open={genderWarningOpen}
                onClose={() => {
                    setGenderWarningOpen(false);
                    onCloseModal?.();
                }}
            >
                <DialogTitle>{t("warning") || "Uyarı"}</DialogTitle>
                <DialogContent>
                    <ByzMuiTypography>
                        {t("partograf-form.female-only-warning") || "Bu form yalnızca Bayan hastalara doldurulabilir!"}
                    </ByzMuiTypography>
                </DialogContent>
                <DialogActions>
                    <Button
                        onClick={() => {
                            setGenderWarningOpen(false);
                            onCloseModal?.();
                        }}
                        variant="contained"
                    >
                        {t("buttons.okey") || "Tamam"}
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
};

export default PartographDialogs;
